import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Permission-gated route. Admin always passes. `perm` may be one string or
 * an array where any permission grants access.
 */
export default function PermRoute({ perm, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "admin") return children;
  const perms = user.permissions || [];
  const required = Array.isArray(perm) ? perm : [perm];
  if (required.some((p) => perms.includes(p))) return children;
  return <Navigate to="/" replace />;
}
